import { queryOptions, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import { ClientDetailsGetClientInvestmentInfoRequest } from 'bff/client';

export const useInvalidateClientInvestmentInfo = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['ClientInvestmentInformation'],
      refetchType: 'all'
    });
};

export const getClientInvestmentInfo = (request: ClientDetailsGetClientInvestmentInfoRequest) => {
  const { clientDetailsApi } = useApiClient();

  return queryOptions({
    queryKey: ['ClientInvestmentInformation'],
    queryFn: async () => clientDetailsApi.clientDetailsGetClientInvestmentInfo(request),
    select: (response) => response.data
  });
};
